import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiMenu } from "react-icons/fi"; // Hamburger icon
import { IoClose } from "react-icons/io5"; // Close icon
import logo from "../../Assets/images/Amn-Logo 1.svg";

export default function Header() {
  const [activeSection, setActiveSection] = useState(null);
  const [activeDropSection, setActiveDropSection] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // Track which dropdown is open
  const [activeMobileDropdown, setActiveMobileDropdown] = useState(null); // Track which mobile dropdown is open
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = decodeURIComponent(location.pathname);
    if (currentPath === "/") {
      setActiveSection("صفحہ اول");
    } else if (currentPath === "/taaruf") {
      setActiveSection("تعارف");
    } else if (currentPath.startsWith("/tableeghat")) {
      setActiveSection("تبلیغات");
      if (currentPath.includes("noordiary")) {
        setActiveDropSection("نور ڈائری");
      } else if (currentPath.includes("mujallah")) {
        setActiveDropSection("نور عصر مجلہ");
      } else if (currentPath.includes("ourBooks")) {
        setActiveDropSection("مطبوعات");
      }
    } else if (currentPath.startsWith("/tazakurat")) {
      setActiveSection("تذکرات");
    }
    // } else if (currentPath.startsWith("/munasibat")) {
    //   // Check which munasibat subpage is active
    //   setActiveSection("مناسبات");
    //   if (currentPath.includes("jashnenoor")) {
    //     setActiveDropSection("جشن نور");
    //   } else if (currentPath.includes("muharram")) {
    //     setActiveDropSection("محرم الحرام");
    //   } else if (currentPath.includes("ayyamefatamiya")) {
    //     setActiveDropSection("ایام فاطمیہ");
    //   } else if (currentPath.includes("exhibition")) {
    //     setActiveDropSection("ایگزیبیشن");
    //   }else if (currentPath.startsWith("/munasibat")) {
    //   // Check which munasibat subpage is active
    //   setActiveSection("مناسبات");
    //   if (currentPath.includes("jashnenoor")) {
    //     setActiveDropSection("جشن نور");
    //   } else if (currentPath.includes("muharram")) {
    //     setActiveDropSection("محرم الحرام");
    //   } else if (currentPath.includes("ayyamefatamiya")) {
    //     setActiveDropSection("ایام فاطمیہ");
    //   } else if (currentPath.includes("exhibition")) {
    //     setActiveDropSection("ایگزیبیشن");
    //   } else {
    //     setActiveDropSection("مناسبات");
    //   }
    // }
    // }

    if (activeSection === "نور عصر مجلہ" || activeSection === "نور ڈائری") {
    }

    window.scrollTo(0, 0);
  }, [location, activeSection]);

  const menuItems = [
    // {
    //     id: 1,
    //     name: "مناسبات",
    //     isDropdown: true,
    //     defaultRoute: "/munasibat/jashnenoor", // Default route for main item
    //     dropdownItems: [
    //         { id: 1, name: "ایگزیبیشن", route: "/munasibat/exhibition" },

    //     ]
    // },
    {
      id: 1,
      name: "تذکرات",
      route: "/tazakurat",
    },
    {
      id: 2,
      name: "تبلیغات",
      isDropdown: true,
      defaultRoute: "/tableeghat/noordiary",
      dropdownItems: [
        { id: 1, name: "نور ڈائری", route: "/tableeghat/noordiary" },
        { id: 2, name: "نور عصر مجلہ", route: "/tableeghat/mujallah" },
        { id: 3, name: "مطبوعات", route: "/tableeghat/ourBooks" },
      ],
    },
    { id: 3, name: "تعارف", route: "/taaruf" },
    { id: 4, name: "صفحہ اول", route: "/" },
  ];

  // Helper to determine if a main menu item should be highlighted
  const isMainActive = (item) => {
    if (!item.isDropdown) return activeSection === item.name;
    // مناسبات
    // if (item.name === "مناسبات") {
    //   return ["مناسبات", "جشن نور", "محرم الحرام", "ایام فاطمیہ"].includes(
    //     activeSection,
    //   );
    // }
    // تبلیغات
    if (item.name === "تبلیغات") {
      return ["تبلیغات", "نور ڈائری", "نور عصر مجلہ", "مطبوعات"].includes(
        activeSection,
      );
    }
    return false;
  };

  const handleMainItemClick = (item) => {
    if (item.isDropdown) {
      // Navigate to default route for dropdown items
      setActiveSection(item.name);
      navigate(item.defaultRoute || item.dropdownItems[0].route); // Use defaultRoute or first dropdown item
      if (window.innerWidth <= 1024) {
        setActiveMobileDropdown((prev) => (prev === item.id ? null : item.id));
      }
    } else {
      // Navigate to the item's route for non-dropdown items
      setActiveSection(item.name);
      navigate(item.route);
      setIsMenuOpen(false);
      setActiveMobileDropdown(null);
    }
  };

  const handleDropdownClick = (route, name) => {
    navigate(route.startsWith("/") ? route : `/${route}`);
    setActiveSection(name); // Set active section to dropdown item name
    setIsMenuOpen(false);
    setActiveMobileDropdown(null);
    setOpenDropdown(null);
  };

  return (
    <div className="sticky top-0 z-50">
      {/* Top Section (bg-primary) - Not sticky */}
      <div className="h-[35px] lg:h-[40px] px-5 md:px-10 lg:px-20 bg-primary w-full flex items-center justify-between text-white">
        <p className="font-alMajeed text-sm md:text-lg lg:text-xl">
          وَصَلَّی اللّٰہُ عَلَیْکَ یَا وَلِیَ الْعَصْرِ (عج) اَدْرِکْنَا
        </p>
        <p className="font-alMajeed text-sm md:text-lg lg:text-xl">
          بِسمِ اللّہِ الرَّحْمٰن الرَّحِیْم
        </p>
      </div>

      {/* Bottom Section (bg-primaryBG) - Sticky */}
      <div className="sticky top-0 bg-primaryBG z-10 w-full h-[88px] flex items-center justify-between px-4 md:px-10 lg:justify-center">
        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center gap-x-6">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="relative my-2 font-nastaleeqRegular"
              onMouseEnter={() => item.isDropdown && setOpenDropdown(item.id)}
              onMouseLeave={() => item.isDropdown && setOpenDropdown(null)}
            >
              <button
                onClick={() => handleMainItemClick(item)}
                className={`relative flex text-[1.5rem] font-semibold items-center gap-x-2 px-6 py-2 w-full
                                    ${isMainActive(item) ? "text-primary" : "text-black"}
                                `}
              >
                <span>{item.name}</span>
                {isMainActive(item) && (
                  <span className="absolute bottom-[-3px] left-1/2 transform -translate-x-1/2 w-1/2 h-[2px] bg-primary transition-all duration-300 ease-in-out"></span>
                )}
              </button>

              {/* Dropdown Menu */}
              {item.isDropdown && openDropdown === item.id && (
                <div className="absolute top-full right-5 w-48 bg-white shadow-md rounded-md py-2 z-20">
                  {item.dropdownItems.map((dropdownItem) => (
                    <button
                      key={dropdownItem.id}
                      onClick={() =>
                        handleDropdownClick(
                          dropdownItem.route,
                          dropdownItem.name,
                        )
                      }
                      className={`block w-full text-right px-4 py-2 hover:bg-primaryBG
                                                ${activeDropSection === dropdownItem.name ? "text-primary" : "text-black"}
                                            `}
                    >
                      {dropdownItem.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Mobile Hamburger Menu */}
        <div className="flex lg:hidden items-center">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-3xl text-black focus:outline-none"
          >
            <FiMenu />
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        <div
          className={`fixed top-0 left-0 h-full w-1/2 bg-secondary z-20 transform ${
            isMenuOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out`}
        >
          <div className="flex justify-end p-4">
            <button
              onClick={() => setIsMenuOpen(false)}
              className="absolute top-2.5 -right-1 text-3xl text-white focus:outline-none px-2"
            >
              <IoClose />
            </button>
          </div>
          <div className="flex flex-col items-start pt-3 px-3 font-nastaleeqRegular">
            {menuItems
              .slice()
              .reverse()
              .map((item) => (
                <div key={item.id} className="w-full">
                  <button
                    onClick={() => handleMainItemClick(item)}
                    className={`w-full text-right text-2xl my-2 py-2 px-4 rounded-md ${
                      activeSection === item.name
                        ? "bg-white text-secondary border-b-2 border-secondary"
                        : "text-white"
                    }`}
                  >
                    {item.name}
                  </button>
                  {item.isDropdown && activeMobileDropdown === item.id && (
                    <div className="pl-4">
                      {item.dropdownItems.map((dropdownItem) => (
                        <button
                          key={dropdownItem.id}
                          onClick={() =>
                            handleDropdownClick(dropdownItem.route)
                          }
                          className={`block w-full text-right text-white text-lg my-1 py-1 px-8 rounded
                                                    ${activeSection === dropdownItem.name ? "bg-gray-700" : ""}
                                                `}
                        >
                          {dropdownItem.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>

        {/* Logo */}
        <div className="absolute right-4 top-4">
          <img
            src={logo}
            alt="Logo"
            className="h-[60px] cursor-pointer"
            onClick={() => {
              navigate("/");
              setActiveSection("صفحہ اول");
            }}
          />
        </div>

        {/* Background overlay for mobile menu */}
        {isMenuOpen && (
          <div
            onClick={() => setIsMenuOpen(false)}
            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-10 lg:hidden"
          ></div>
        )}
      </div>
    </div>
  );
}
